import { useState } from 'react'

import { Box, Button, Icon, Modal, Text } from '@fairfashion/design-system'

import { docMask } from '../../../utilities/masks/brasilianDocuments'

interface ClientsCustomColumnProps {
  value?: any
}

export const ClientsCustomColumn = ({ value }: ClientsCustomColumnProps) => {
  const [open, setOpen] = useState(false)

  if (!value?.clients || !value?.clients.length) return null

  const clients = value.clients

  return (
    <Box width="60px" justifyContent="center">
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box paddingY={2} direction="column">
          {clients.map((client: any, index: number) => (
            <Box key={`item-${index}`} gap={2} width="100%">
              <Text color="grey_3">{`${index + 1}.`}</Text>
              <Text color="grey_1">
                {docMask(client.taxId)} - {client.name}
              </Text>
            </Box>
          ))}
        </Box>
      </Modal>

      <Button variant="text" onClick={() => setOpen(true)}>
        <Icon name="community" color="grey_2" size={24} />
      </Button>
    </Box>
  )
}
